export default  {
    getTakeawayMut (state, payload) {
        state.takeaway.takeaways = payload
    },
    clearTakeawayMut (state) {
        state.takeaway.takeaways = null
    }
    
}